const { fetchSingle: fetchSingleSection } = window.BAO.sectionRenderer
const { getElements } = window.BAO.Utils

class QuickAdd extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.hasGlobalClickListener = false
  }

  connectedCallback () {
    super.connectedCallback()

    this.attachGlobalListeners()
  }

  disconnectedCallback () {
    this.detachGlobalListeners()
    super.disconnectedCallback()
  }

  attachGlobalListeners () {
    if (this.hasGlobalClickListener) return

    document.addEventListener('click', this.handleTrigger)
    this.hasGlobalClickListener = true
  }

  detachGlobalListeners () {
    if (!this.hasGlobalClickListener) return

    document.removeEventListener('click', this.handleTrigger)
    this.hasGlobalClickListener = false
  }

  async handleTrigger (event) {
    const target = event.target
    const trigger = target.closest('[data-quick-add-external-el="trigger"]')

    if (!trigger || trigger.getAttribute('aria-busy') === 'true') return

    trigger.setAttribute('aria-busy', true)

    try {
      const productUrl = trigger.dataset.productUrl

      const response = await fetchSingleSection('drawer-quick-add', productUrl)

      const newDOM = window.BAO.sectionRenderer.convertToDOM(response)
      const bodyContent = newDOM.querySelector('.drw-QuickAdd')

      const productForms = getElements('[data-push-cart-form]', {
        context: bodyContent,
      })

      productForms.forEach((formEl) => {
        formEl.dataset.gtmTargetContext = 'quickbuy-product-form'
      })

      // Update product form Nosto type for analytics
      const productCard = target.closest('.prd-Card')
      const nostoType = productCard?.dataset.nostoType

      if (nostoType) {
        const placementId = trigger.closest('.nosto_element')?.id

        productForms.forEach((formEl) => {
          formEl.dataset.nostoType = nostoType

          if (placementId) {
            formEl.dataset.nostoPlacementId = placementId
          }
        })
      }

      // Update body
      this.els.body.element.innerHTML = bodyContent.outerHTML

      window.drawers.activeDrawerKey = 'quick-add'

      const nextDrawerKey = trigger.getAttribute('data-next-drawer-key')
      if (nextDrawerKey) {
        window.drawers.nextActiveDrawerKey = nextDrawerKey
      }
    } catch (error) {
      window.drawers.activeDrawerKey = ''
      console.error(error)
    } finally {
      trigger.setAttribute('aria-busy', false)
    }
  }
}

if (!customElements.get('quick-add')) {
  customElements.define('quick-add', QuickAdd)
}
